import apiClient from "./interceptorsApiCall.js";
import { decryptResponse } from "./interceptorsApiCall.js";



export const chatbotAns = async () => {
  const url = `/chatbot`;
  try {
    const response = await apiClient.get(url);

    return { data: response.data, error: null };
  } catch (error) {
    console.error("Error fetching DiscussionLog data:", error);
    return { data: null, error };
  }
};

export const chatbotAnsPost = async (queChat) => {
  try {
    const response = await apiClient.post(`/chat_pdf`, queChat, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return decryptResponse(response.data);
  } catch (error) {
    console.error("Error sending Question :", error);
    return decryptResponse(error);
  }
};






export const waveflowApi = async (waveflowData) => {
  try {
    const response = await apiClient.post(`/assign_roles`, waveflowData, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return decryptResponse(response.data);
  } catch (error) {
    return decryptResponse(error);
  }
};

export const waveflowTestingApi = async (waveflowData) => {
  try {
    const response = await apiClient.post(`/prompt_testing`, waveflowData, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const enhancePrompt = async (waveflowData) => {
  try {
    const response = await apiClient.post(`/enhance_prompt`, waveflowData, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return decryptResponse(response.data);
  } catch (error) {
    return decryptResponse(error);
  }
};

export const GettingAllAgents = async () => {
  try {
    const response = await apiClient.get(`/get-agents`);

    return decryptResponse(response.data);
  } catch (error) {
    console.error("Error fetching folder files:", error);
    return decryptResponse(error);
  }
};

export const submitFlowSequence = async (payload) => {
  try {
    const response = await apiClient.post(`/names`, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const runFlowSequence = async (payload) => {
  try {
    const response = await apiClient.post(`/run`, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return decryptResponse(response.data);
  } catch (error) {
    return decryptResponse(error);
  }
};

export const saveFlowSequence = async (payload) => {
  try {
    const response = await apiClient.post(`/save`, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return decryptResponse(response.data);
  } catch (error) {
    return decryptResponse(error);
  }
};

export const workflowApi = async (payload) => {
  try {
    const response = await apiClient.post(`/workflow`, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const add_executorApi = async (payload) => {
  try {
    const response = await apiClient.post(`/add_executor`, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return decryptResponse(response.data);
  } catch (error) {
    return decryptResponse(error);
  }
};

export const updatedAgentApi = async (payload) => {
  try {
    const response = await apiClient.post(`/update-agent`, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return decryptResponse(response.data);
  } catch (error) {
    return decryptResponse(error);
  }
};

export const setModelApi = async (payload) => {
  try {
    const response = await apiClient.post(`/set_model`, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return decryptResponse(response.data);
  } catch (error) {
    return decryptResponse(error);
  }
};

export const testModelApi = async (payload) => {
  try {
    const response = await apiClient.post(`/model_health_check`, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return decryptResponse(response.data);
  } catch (error) {
    return decryptResponse(error);
  }
};

export const GettingAllModels = async () => {
  try {
    const response = await apiClient.get(`/get_models`);

    return decryptResponse(response.data);
  } catch (error) {
    console.error("Error fetching folder files:", error);
    return decryptResponse(error);
  }
};

export const deleteModelApi = async (modelId) => {
  try {
    const response = await apiClient.delete(`/delete_model/${modelId}`, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return decryptResponse(response.data);
  } catch (error) {
    console.error("Error deleting model:", error);
    return decryptResponse(error);
  }
};

export const GettingAllTools = async () => {
  try {
    const response = await apiClient.get(`/get_tools`);

    return decryptResponse(response.data);
  } catch (error) {
    console.error("Error fetching folder files:", error);
    return decryptResponse(error);
  }
};

export const deleteToolsApi = async (toolId) => {
  try {
    const response = await apiClient.delete(`/delete-tool/${toolId}`, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return decryptResponse(response.data);
  } catch (error) {
    console.error("Error deleting model:", error);
    return decryptResponse(error);
  }
};

export const resetFlowApi = async () => {
  try {
    const res = await apiClient.get(`/reset`);
    return decryptResponse(res.data);
  } catch (error) {
    console.error("Reset api error", error);
    return decryptResponse(error);
  }
};

export const GettingAllWorkFlow = async () => {
  try {
    const response = await apiClient.get(`/workflow_admin`);

    return decryptResponse(response.data);
  } catch (error) {
    console.error("Error fetching folder files:", error);
    return decryptResponse(error);
  }
};

export const GettingWorkFlowId = async (payload) => {
  try {
    const response = await apiClient.post(`/agent_data`, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return decryptResponse(response.data)
  } catch (error) {
    return decryptResponse(error);
  }
};

export const GettingChatHistory = async (payload) => {
  try {
    const response = await apiClient.post(
      `/get-session-history`,
      { session_id: payload },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return decryptResponse(response.data);
  } catch (error) {
    return decryptResponse(error);
  }
};

export const getBedrockModelsApi = async () => {
  try {
    const response = await apiClient.get("/get-bedrock-models");
    return decryptResponse(response.data);
  } catch (error) {
    console.error("Error fetching Bedrock models:", error);
    return [];
  }
};

export const getAliBabaModelsApi = async () => {
  try {
    const response = await apiClient.get("/get-alibaba-models");
    return decryptResponse(response.data);
  } catch (error) {
    console.error("Error fetching Bedrock models:", error);
    return [];
  }
};

export const startchatapi = async (payload) => {
  try {
    const response = await apiClient.post(
      `/workflow-admin-run`,
      { session_id: payload },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return decryptResponse(response.data);
  } catch (error) {
    return decryptResponse(error);
  }
};

export const deletedeleteworkflow = async (id) => {
  try {
    const response = await apiClient.delete(`/delete-workflow/${id}`, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return decryptResponse(response.data);
  } catch (error) {
    console.error("Error deleting model:", error);
    return decryptResponse(error);
  }
};

export const runWorkFlowAdmin = async (payload) => {
  try {
    const response = await apiClient.post(
      `/workflow-admin-run`,
      { session_id: payload },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return decryptResponse(response.data);
  } catch (error) {
    return decryptResponse(error);
  }
};

export const workflowrunchatpdf = async (payload) => {
  try {
    const response = await apiClient.post(
      `/workflow-run-chat-pdf`,
      { session_id: payload },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return decryptResponse(response.data);
  } catch (error) {
    return decryptResponse(error);
  }
};

export const geetingNameListModel = async (modelname) => {
  try {
    const response = await apiClient.get(`/get-${modelname}-models`);

    return decryptResponse(response.data);
  } catch (error) {
    console.error("Error fetching folder files:", error);
    return decryptResponse(error);
  }
};

export const workflowautomationSchedule = async (payload) => {
  try {
    const formData = new FormData();

    formData.append("flowDesc", payload.flowDesc);
    formData.append("flowname", payload.flowname);
    formData.append("query", payload.query);
    formData.append("session_id", payload.session_id);
    formData.append("time", payload.time);
    formData.append("workflow_type", payload.workflow_type);

    if (payload.files && payload.files.length > 0) {
      formData.append("files", payload.files[0]); // Append the first file (for multiple, use a loop)
    }

    const response = await apiClient.post(`/schedule-workflow`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error in API call:", error);
    return error;
  }
};


export const testAutomationWorkflowApi = async (payload) => {
  try {
    const formData = new FormData();


    formData.append("query", payload.query);
    formData.append("session_id", payload.session_id);
    formData.append("workflow_type", payload.workflow_type);

    // For the structure you're targeting
    formData.append("cycle_type", payload.cycleType); // e.g. 'regular_interval'

    // Convert the entire config object to JSON string
    const config = {
      start_date: payload.start_date,
      start_time: payload.start_time,
      repeat_interval: payload.repeat_interval,
      repeat_unit: payload.repeat_unit,
      number_of_cycles: payload.cycle_count,
    };
    formData.append("config", JSON.stringify(config));

    if (payload.files && payload.files.length > 0) {
      formData.append("filenames", JSON.stringify(payload.files));
    }


    const response = await apiClient.post(
      `/test-automation-workflow`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return decryptResponse(response.data);
  } catch (error) {
    console.error("Error in API call:", error);
    return decryptResponse(error);
  }
};

export const getPromptFramework = async () => {
  try {
    const response = await apiClient.get(`/prompt_framework`);

    return decryptResponse(response.data.content);
  } catch (error) {
    console.error("Error fetching folder files:", error);
    console.log("error",decryptResponse(error));
  }
};

//?tools details

// export const getAllToolsData = async () => {
//   const options = {
//     method: "GET",
//     headers: { "x-api-key": "hn2uypk97apxaosq5opxhb" },
//   };

//   try {
//     let response = {
//       method: "GET",
//       headers: { "x-api-key": "hn2uypk97apxaosq5opxhb" },
//     };

//     fetch("https://backend.composio.dev/api/v1/apps", options)
//       .then((response) => response.json())
//       .then((response) => console.log("response", response))
//       .catch((err) => console.error(err));

//     return response.data;
//   } catch (error) {
//     console.error("Error fetching folder files:", error);
//   }
// };

export const getAllToolsData = async () => {
  try {
    const response = await apiClient.get("/apps");

    return decryptResponse(response.data);
  } catch (error) {
    console.error("Error fetching tools data:", error);
    return decryptResponse(error);
  }
};

export const ToolsInitiateConnection = async (payload) => {
  try {
    const response = await apiClient.post(`/initiate-connection`, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return decryptResponse(response.data);
  } catch (error) {
    return decryptResponse(error);
  }
};

export const getConnections = async () => {
  try {
    const response = await apiClient.get(`/connections`);

    return decryptResponse(response);
  } catch (error) {
    console.error("Error fetching folder files:", error);
  }
};

export const promptTestingCopyApi = async (payload) => {
  try {
    const response = await apiClient.post(`/prompt_testing_copy`, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return decryptResponse(response.data);
  } catch (error) {
    return decryptResponse(error);
  }
};

export const savePromptApi = async (payload) => {
  try {
    const response = await apiClient.post(`/save_prompt`, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return decryptResponse(response.data);
  } catch (error) {
    return decryptResponse(error);
  }
};

export const getAllPropmtDataApi = async () => {
  try {
    const response = await apiClient.get(`/show_all_prompt_data`);
    return decryptResponse(response.data);
  } catch (error) {
    console.log("error",decryptResponse(error.response.data));
    return decryptResponse(error);
  }
};

export const fetchpromptdataApi = async (payload) => {
  try {
    const response = await apiClient.post(`/fetch_prompt_data`, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return decryptResponse(response.data);
  } catch (error) {
    return error;
  }
};

export const getEnumsbyAppApi = async (payload) => {
  try {
    const response = await apiClient.post(`/get-enums-by-app`, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return decryptResponse(response.data);
  } catch (error) {
    return decryptResponse(error);
  }
};

export const getAlltoken_data = async () => {
  try {
    const response = await apiClient.get(`/token_data`);
    console.log(decryptResponse(response.data))
    return decryptResponse(response.data);
  } catch (error) {
    return decryptResponse(error);
  }
};

export const getAllworkflows_Data = async () => {
  try {
    const response = await apiClient.get(`/session_data`);
    console.log(decryptResponse(response.data))
    return decryptResponse(response.data);
  } catch (error) {
    return decryptResponse(error);
  }
};

//authenticated user Data fetch
export const fetchUserData = async () => {
  const isNotMocked = process.env.REACT_APP_AUTH_ACTIVATED;
  try {
    if (isNotMocked === "true") {
      const response = await apiClient.get(`/auth/user`);
      return response.data.data;
    } else {
      return mockResponse.data;
    }
  } catch (error) {
    console.error("Error fetching folder files:", error);
  }
};

export const geetingOpenAIModels = async () => {
  try {
    const response = await apiClient.get("/get-openai-models");
    return decryptResponse(response.data);
  } catch (error) {
    console.error("Failed to fetch OpenAI models", error);
    return [];
  }
};

const mockResponse = {
  resultType: 0,
  data: {
    email: "samundersingh1983@gmail.com",
    displayName: "Samunder Singh",
    isActive: true,
    group: null,
    subscription: {
      userId: "7de27ae1-7f58-430f-a04e-6f045620767c",
      planId: "7a5f556e-5213-4288-9410-04aa9355bf43",
      startDate: "2024-11-17T10:44:08.684587Z",
      endDate: "2024-12-17T10:44:08.684635Z",
      maxUser: 1,
      status: "Active",
      subscriptionPlan: {
        planKey: "Free",
        planName: "Free",
        description: "Free for all users to get started with our agent",
        price: 0,
        currency: "USD",
        durationDays: 30,
        id: "7a5f556e-5213-4288-9410-04aa9355bf43",
      },
      id: "4e0e3027-b20b-4708-84d3-6ef274ae8d01",
    },
    roles: [
      {
        roleKey: "User",
        roleName: "User",
        maxTokenAllowed: 100000,
        description:
          "User with limited access and yet to subscribe and subscription.",
        isActive: true,
        id: "c8c2dd47-6b5c-4406-a740-59827209d0b2",
      },
    ],
    permissions: ["DocumentUpload", "Tools"],
    id: "7de27ae1-7f58-430f-a04e-6f045620767c",
  },
  totalRecords: 0,
  message: "",
  stackTrace: "",
  validationErrors: null,
};

export const scheduleAutomationWorkflowApi = async (payload) => {
  try {
    const response = await apiClient.post(
      `/test-automation-workflow`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return decryptResponse(response.data);
  } catch (error) {
    return decryptResponse(error);
  }
};

//payment apis
export const paymentCreateOrderId = async (payload) => {
  try {
    const response = await apiClient.post(`/create-payment-order`, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    // console.log("response",response.data);
    return decryptResponse(response.data)
  } catch (error) {
    return decryptResponse(error);
  }
};

export const paymentVerifyOrder = async (payload) => {
  try {
    const response = await apiClient.post(`/verify-payment`, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return decryptResponse(response.data);
  } catch (error) {
    return decryptResponse(error);
  }
};

export const getPaymentDetails = async (payload) => {
  try {
    const response = await apiClient.post(`/get-details`, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const storePaymentRecord = async (payload) => {
  try {
    const response = await apiClient.post(`/store-payment`, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return decryptResponse(response.data);
  } catch (error) {
    return decryptResponse(error);
  }
};

export const updateUser = async (payload) => {
  try {
    const response = await apiClient.post(`/update-user`, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const addUsers = async (payload) => {
  try {
    const response = await apiClient.post(`/login`, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    return error;
  }
};

//plan-apis

export const fetchUserDetails  = async () => {
  try {
    const res = await apiClient.get("/profile/user-details");
    // const response={
    //   data:{
    //     plan:"standard"
    //   }
    // }
    return decryptResponse(res?.data?.user ?? res?.data);
  } catch (error) {
    console.error("Failed to fetch user Details", error);
    return decryptResponse(error);
  }
};


export const updateUserRuns = async (payload) => {
  try {
    const response = await apiClient.post(`/update-user-runs`, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const updateUserWorkflows = async (payload) => {
  try {
    const response = await apiClient.post(`/update-user-workflows`, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    return error;
  }
};


export const DeployApi = async (payload) => {
  try {
    const res = await apiClient.post("/deploy", payload, {
      headers: { "Content-Type": "application/json" },
    });
    return decryptResponse(res.data);
  } catch (err) {
    console.error("Deploy API error:", err);
    return decryptResponse(err);
  }
};

export const editWorkflowPost = async (sessionId) => {
  try {
    const response = await apiClient.post(
      "/edit_workflow",
      {},
      {
        params: { session_id: sessionId }, 
      }
    );

    return decryptResponse(response.data);
  } catch (error) {
    console.error("Error editing workflow:", error);
    throw error;
  }
};

export const createAgentApi = async (payload) => {
  try {
    const res = await apiClient.post("/create_agent", payload, {
      headers: { "Content-Type": "application/json" },
    });
    return decryptResponse(res.data);
  } catch (err) {
    console.error("Error while creating agent", err);
    throw err;
  }
};
